import { render } from "./_OurMembers.vue?vue&type=template&id=5d3241fb&lang=en"
import script from "./_OurMembers.vue?vue&type=script&lang=js"
export * from "./_OurMembers.vue?vue&type=script&lang=js"

import "./_OurMembers.vue?vue&type=style&index=0&id=5d3241fb&lang=scss"

import exportComponent from "/usr/local/var/www/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__